import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { I18NextPipe } from 'angular-i18next';
import { Balance } from 'mbs-ui-shared@components/components/models/license.model';
import { BALANCE_TOKEN } from 'mbs-ui-shared@components/licenses/tokens/balance.token';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { LicensesFacade } from 'mbs-ui-shared@facades/licenses.facade';
import { PaymentMethodsService } from 'mbs-ui-shared@services/payment-methods.service';
import { Observable, filter, map } from 'rxjs';

@Component({
  selector: 'mbs-payment-method-button',
  standalone: true,
  imports: [I18NextPipe],
  templateUrl: './payment-method-button.component.html',
  styleUrls: ['./payment-method-button.component.css']
})
export class PaymentMethodButtonComponent {
  private auth = inject(AuthFacade);
  private paymentMethods = inject(PaymentMethodsService);

  private isAutoPay = toSignal(
    inject<Observable<Balance>>(BALANCE_TOKEN).pipe(
      filter(Boolean),
      map((balance) => balance.subscriptionEnabled)
    )
  );

  private subscriptionEditLink = toSignal(inject(LicensesFacade).subscriptionEditLink);

  protected handleClick(event: Event): void {
    event.preventDefault();

    const link = this.subscriptionEditLink();

    this.paymentMethods.open(this.isAutoPay() && link ? link : this.auth.subscriptionUrl);
  }
}
